var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('p',{staticStyle:{"margin-left":"20px","font-weight":"bold"}},[_vm._v("您没有该操作权限!")])])}]

export { render, staticRenderFns }